import { RegionShared } from "@1games-ru/region-shared";
import { useEffect } from "react";
import rpc from "@1games-ru/rage-rpc";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import useAppSelector from "@/core/helpers/useAppSelector";
import useInterfaceSoundCore from "@/shared/hooks/useInterfaceSoundCore";
import { Soundtrack } from "@/shared/sounds";
import { DeviceEnum } from "@/domains/business/constants/deviceEnum";
import { setDevice } from "@/domains/business/slice";
import { clear } from "@/domains/estate/slice";
import {
  setActiveApp,
  setAppsList,
  setIsShow,
  setIsVisible,
  tabletIsVisible,
} from "@/domains/tablet/slice";

export default function useShowTablet(setIsLock: (arg: boolean) => void) {
  const dispatch = useAppDispatch();
  const isVisible = useAppSelector(tabletIsVisible);
  const { play } = useInterfaceSoundCore(Soundtrack.Swipe);

  useEffect(() => {
    rpc.register(RegionShared.Cef.Events.Tablet.Show, (state) => {
      if (!isVisible) {
        dispatch(setIsVisible(true));
        return;
      }
      dispatch(setDevice(DeviceEnum.TABLET));
      dispatch(setIsShow(true));
      dispatch(setAppsList(state.applications));
    });

    return () => {
      rpc.unregister(RegionShared.Cef.Events.Tablet.Show);
    };
  }, [dispatch, isVisible]);

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;

    rpc.register(
      RegionShared.Cef.Events.Tablet.Hide,
      (state: typeof RegionShared.Cef.Requests.TabletHideRequest) => {
        if (!state.saveState) {
          dispatch(setActiveApp(null));
          timeoutId = setTimeout(() => {
            dispatch(clear());
          }, 200);

          dispatch(setIsShow(false));
          dispatch(setDevice(null));
          setIsLock(true);
          play();
        } else {
          dispatch(setIsVisible(false));
        }
      },
    );

    return () => {
      rpc.unregister(RegionShared.Cef.Events.Tablet.Hide);
      clearTimeout(timeoutId);
    };
  }, [dispatch, play, setIsLock]);
}
